import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { 
  ExternalLink, 
  MapPin, 
  Coffee, 
  Briefcase, 
  TrendingUp, 
  ShoppingCart, 
  Play,
  Smartphone, 
  Check
} from 'lucide-react';

interface Project {
  title: string;
  category: string;
  link?: string;
  icon: React.ComponentType<any>;
  image?: string;
  description: string;
  technologies: string[];
  gradient: string;
}

const Portfolio: React.FC = () => {
  const [activeFilter, setActiveFilter] = useState('All');

  const projects: Project[] = [
     {
      title: 'Travel Tour - Hotel Booking',
      category: 'Web Development',
      icon: ShoppingCart,
      link: 'https://tour-hotel-booking.palawanfreelancer.com',
      description: 'The platform offers integrated travel tours and hotel booking with curated itineraries, seamless reservations, exclusive deals, and flexible options for solo travelers, couples, families, and groups.',
      image: '/images/cover-tour-hotel-booking.png',
      technologies: ['MongoDB', 'Express', 'React', 'Node Js', 'TypeScript', 'Tailwind CSS'],
      gradient: 'from-blue-500 to-cyan-500'
    },
   
    {
      title: 'The RichST Cafe',
      category: 'Web Development',
      icon: Briefcase,
      link: 'https://therichst-cafe.net',
      description: 'The platform features a comprehensive multi-level marketing system with product catalog management for cologne, cafe products, water distribution, loan services, and peer-to-peer transactions.',
       image: '/images/cover-richstcafe.jpg',
      technologies: ['PHP', 'Laravel', 'MYSQL', 'bootstrap css'],
      gradient: 'from-emerald-500 to-teal-500'
    },
    {
      title: 'Code Keep',
      category: 'Web Development',
      icon: Briefcase,
      link: 'https://code-keep-eight.vercel.app',
      description: 'Snippets, prompts, commands, notes, files, and links — scattered across a dozen tools. Code Keep brings everything into one searchable hub.',
      image: '/images/cover-code-keep.png',
      technologies: ['NextJs', 'React', 'PostgreSQL','Next-Auth','Prisma', 'TypeScript', 'Tailwind CSS'],
      gradient: 'from-emerald-500 to-teal-500'
    },
     {
      title: 'MINE AI PRO',
      category: 'Web Development',
      icon: ShoppingCart,
      link: 'https://mineaipro.com',
      description: 'Discover the advanced technology behind our cloud mining platform powered by industry-leading infrastructure',
      image: '/images/cover-mine-ai-pro.jpg',
      technologies: ['PHP', 'Laravel', 'React', 'MYSQL', 'TypeScript', 'Tailwind CSS'],
      gradient: 'from-blue-500 to-cyan-500'
    },
    {
      title: 'My Happy Coin',
      category: 'Web Development',
      icon: Briefcase,
      link: 'https://www.myhappycoin.shop',
      description: 'Cryptocurrency trading platform with integrated MLM system, featuring digital wallet management, token trading, and blockchain-based reward distribution.',
      image: '/images/cover-myhappycoin.jpg',
      technologies: ['PHP', 'Laravel', 'React', 'MYSQL', 'TypeScript', 'Tailwind CSS'],
      gradient: 'from-emerald-500 to-teal-500'
    },
    {
      title: 'SASS AI Agent Platform',
      category: 'Web Development',
      icon: Briefcase,
      link: 'https://nextjs-saas-ai-agent-platform.vercel.app/sign-in',
      description: 'AI-powered video call platform featuring custom real-time agents, meeting summaries, transcripts, recordings, meeting history, transcript search, video playback, and AI meeting Q&A powered by Stream Video & Chat SDK.',
      image: '/images/cover-ai-agent.jpg',
      technologies: ['Next JS', 'PostgreSQL', 'Better Auth', 'React', 'Tailwind CSS'],
      gradient: 'from-emerald-500 to-teal-500'
    },
    {
      title: 'SASS Medical Voice Agent',
      category: 'Web Development',
      icon: Briefcase,
      link: 'https://sass-nextjs-medical-voice-agent.vercel.app',
      description: 'A Next.js web application that integrates a medical voice agent using OpenAI API to provide users with medical information and assistance through voice interactions.',
      image: '/images/cover-medical-ai.jpg',
      technologies: ['Next JS', 'PostgreSQL', 'Clerk', 'React', 'Tailwind CSS'],
      gradient: 'from-emerald-500 to-teal-500'
    },
    {
      title: 'Youtube Videos',
      category: 'Web Development',
      icon: Briefcase,
      link: 'https://palawanfreelancer.com/videos/',
      description: 'React application that integrates with the YouTube Data API to fetch and display videos based on user search queries, allowing users to watch videos directly within the app.',
      image: '/images/cover-youtube-videos.jpg',
      technologies: ['React', 'CSS', 'API Integration'],
      gradient: 'from-emerald-500 to-teal-500'
    },
     {
      title: 'Visit Philippines PH',
      category: 'Web Development',
      icon: Briefcase,
      link: 'https://visitphilippines.ph',
      image: '/images/cover-visit-philippines.jpg',
      description: 'A tourism website for the Philippines that showcases destinations, travel guides, and cultural highlights to promote tourism in the country.',
      technologies: ['PHP', 'Laravel', 'MYSQL', 'JavaScript', 'Bootstrap css'],
      gradient: 'from-emerald-500 to-teal-500'
    },
    {
      title: 'Orange Pearl Beach Resort',
      category: 'Web Development',
      icon: Briefcase,
      link: 'https://orangepearlbeachresort.com',
      description: 'A comprehensive hotel information website for Orange Pearl Beach Resort located in the beautiful El Nido, Palawan. Features room bookings, amenities showcase, and tourist information.',
      image: '/images/cover-orange-pearl.jpg',
      technologies: ['PHP', 'Laravel', 'MYSQL', 'JavaScript', 'Bootstrap css'],
      gradient: 'from-emerald-500 to-teal-500'
    },
    {
      title: 'Villa Israele El Nido',
      category: 'Web Development',
      icon: Briefcase,
      link: 'https://villaisraelelnido.com',
      description: 'A resort website for Villa Israele El Nido, showcasing accommodations, amenities, and booking options for tourists visiting El Nido, Palawan.',
       image: '/images/cover-villa-israel.jpg',
      technologies: ['PHP', 'Laravel', 'MYSQL', 'JavaScript', 'Bootstrap css'],
      gradient: 'from-emerald-500 to-teal-500'
    },
    {
      title: 'El Nido Fareast Travel',
      category: 'Web Development',
      icon: Briefcase,
      link: 'https://elnidofareasttravel.com',
      description: 'A travel agency website for El Nido Fareast Travel offering tour packages, booking services, and travel information for tourists visiting El Nido, Palawan.',
      image: '/images/cover-fareastelnido.jpg',
      technologies: ['PHP', 'Laravel', 'MYSQL', 'JavaScript', 'Bootstrap'],
      gradient: 'from-emerald-500 to-teal-500'
    },
    
    {
      title: 'WordPress Custom Solutions',
      category: 'Web Development',
      icon: Coffee,
      link: 'https://red-wombat-900940.hostingersite.com/wp-admin',
      description: 'Built and customized WordPress websites with performance optimization and responsive design.',
      technologies: ['WordPress', 'PHP', 'JavaScript', 'Custom Plugins', 'Performance Optimization'],
      gradient: 'from-orange-500 to-amber-500'
    },
    {
      title: 'E-Commerce Mobile Apps',
      category: 'Mobile Development',
      icon: Smartphone,
      description: 'Developed cross-platform e-commerce mobile applications using Flutter for seamless shopping experiences.',
      technologies: ['Flutter', 'Dart', 'Firebase'],
       image: '/images/cover-mobile-ecommerce.jpg',
      gradient: 'from-pink-500 to-rose-500'
    },
    {
      title: 'Delivery Mobile Apps',
      category: 'Mobile Development',
      icon: Smartphone,
      description: 'Delivery service mobile application with real-time tracking and notifications using React Native.',
      technologies: ['React Native', 'PostgreSQL', 'Express.js'],
      image: '/images/cover-mobile-delivery.jpg',
      gradient: 'from-pink-500 to-rose-500'
    },
    {
      title: 'Crypto Mobile Apps',
      category: 'Mobile Development',
      icon: Smartphone,
      description: 'Cryptocurrency trading mobile application with secure wallet integration using React Native.',
      technologies: ['React Native', 'PostgreSQL', 'Express.js'],
       image: '/images/cover-mobile-crypto.jpg',
      gradient: 'from-pink-500 to-rose-500'
    },
    {
      title: 'Microfinance Software System',
      category: 'Software',
      icon: Briefcase,
      description: 'Developed a comprehensive microfinance software system for managing loans, savings, and client accounts.',
      technologies: ['C#', 'SQL Server', 'Windows Forms', 'Database Design'],
       image: '/images/cover-software-loan.jpg',
      gradient: 'from-purple-500 to-violet-500'
    },
     {
      title: 'Employment Record System',
      category: 'Software',
      icon: Briefcase,
      description: 'Developed an employment record management system to streamline HR processes and employee data management.',
      technologies: ['C#', 'SQL Server', 'Windows Forms', 'Database Design'],
      image: '/images/cover-software-kalayaan.jpg',
      gradient: 'from-purple-500 to-violet-500'
    },
      {
      title: 'POS Inventory System',
      category: 'Software',
      icon: Briefcase,
      description: 'Developed a point-of-sale inventory management system to track sales, inventory levels, and generate reports.',
      technologies: ['C#', 'SQL Server', 'Windows Forms', 'Database Design'],
      image: '/images/cover-software-pos.jpg',
      gradient: 'from-purple-500 to-violet-500'
      
    },
    
    // {
    //   title: 'REST API Development',
    //   category: 'Backend Development',
    //   icon: TrendingUp,
    //   description: 'Designed and integrated REST APIs for seamless service communication and data processing.',
    //   technologies: ['PHP', 'Laravel', 'REST APIs', 'JSON', 'XML Processing'],
    //   gradient: 'from-indigo-500 to-purple-500'
    // },
    // {
    //   title: 'Database Optimization',
    //   category: 'Backend Development',
    //   icon: MapPin,
    //   description: 'Optimized MySQL databases, implemented cron jobs, and improved CSV processing modules.',
    //   technologies: ['MySQL', 'PostgreSQL', 'Database Optimization', 'Cron Jobs', 'SQL'],
    //   gradient: 'from-green-500 to-emerald-500'
    // },
    // {
    //   title: 'Palawan Freelancer Website',
    //   category: 'Web Development',
    //   link: 'https://marioroco.palawanfreelancer.com',
    //   icon: Play,
    //   description: 'Personal portfolio and professional website showcasing skills and experience.',
    //   technologies: ['React', 'TypeScript', 'Tailwind CSS', 'Framer Motion'],
    //   gradient: 'from-red-500 to-pink-500'
    // }
  ];

  const categories = ['All', 'Web Development', 'Mobile Development',  'Software'];
  //const categories = ['All', 'Web Development', 'Mobile Development', 'Backend Development', 'Software'];

  const filteredProjects = activeFilter === 'All' 
    ? projects 
    : projects.filter(project => project.category === activeFilter);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const cardVariants = {
    hidden: { 
      opacity: 0, 
      y: 20,
      scale: 0.9
    },
    visible: { 
      opacity: 1, 
      y: 0,
      scale: 1
    }
  };

  return (
    <section id="projects" className="py-20 bg-slate-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <motion.div
            initial={{ opacity: 0, scale: 0.5 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.2, duration: 0.5 }}
            viewport={{ once: true }}
            className="inline-flex items-center px-4 py-2 rounded-full text-sm font-medium bg-purple-100 text-purple-600 border border-purple-200 mb-4"
          >
            <Check /> My Portfolio
          </motion.div>

          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Featured <span className="text-purple-600">Projects</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            A showcase of diverse projects spanning web development, mobile applications, 
            and enterprise software solutions delivered across multiple industries.
          </p>
        </motion.div>

        {/* Filter Tabs */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3, duration: 0.6 }}
          viewport={{ once: true }}
          className="flex justify-center mb-12"
        >
          <div className="flex flex-wrap gap-3 p-2 bg-white rounded-2xl shadow-lg border">
            {categories.map((category) => (
              <Button
                key={category}
                variant={activeFilter === category ? "default" : "ghost"}
                onClick={() => setActiveFilter(category)}
                className={`
                  px-6 py-3 rounded-xl font-semibold transition-all duration-300
                  ${activeFilter === category 
                    ? 'bg-purple-600 text-white shadow-lg' 
                    : 'text-gray-600 hover:text-purple-600 hover:bg-purple-50'
                  }
                `}
              >
                {category}
              </Button>
            ))}
          </div>
        </motion.div>
        
        {/* Projects Grid */}
        <AnimatePresence mode="wait">
          <motion.div
            key={activeFilter}
            variants={containerVariants}
            initial="hidden"
            animate="visible"
            className="grid md:grid-cols-2 xl:grid-cols-3 gap-8"
          >
            {filteredProjects.map((project, index) => {
              const IconComponent = project.icon;
              return (
                <motion.div
                  key={`${activeFilter}-${index}`}
                  variants={cardVariants}
                  transition={{ duration: 0.5, ease: "easeOut" }}
                  layout
                  whileHover={{ y: -8 }}
                >
                  <Card className="group h-full bg-white/80 backdrop-blur-sm border-0 shadow-xl hover:shadow-2xl transition-all duration-500 overflow-hidden">
                    {/* Project Image/Icon Section */}
                    <div className={`relative h-48 ${project.image ? 'bg-gray-900' : 'bg-slate-700'} flex items-center justify-center overflow-hidden`}>
                      {project.image ? (
                        <motion.img
                          src={project.image}
                          alt={project.title}
                          className="w-full h-full object-cover"
                          whileHover={{ scale: 1.05 }}
                          transition={{ duration: 0.3 }}
                        />
                      ) : (
                        <motion.div
                          whileHover={{ scale: 1.1, rotate: 5 }}
                          transition={{ duration: 0.3 }}
                        >
                          <IconComponent className="h-16 w-16 text-white" />
                        </motion.div>
                      )}
                      
                      {/* Overlay */}
                      <div className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition-all duration-300" />
                      
                      {/* Category Badge */}
                      <div className="absolute top-4 left-4">
                        <span className="px-3 py-1 bg-white/20 backdrop-blur-sm text-white text-xs font-medium rounded-full border border-white/30">
                          {project.category}
                        </span>
                      </div>

                      {/* External Link Icon */}
                      {project.link && (
                        <motion.div
                          initial={{ opacity: 0, scale: 0 }}
                          whileHover={{ opacity: 1, scale: 1 }}
                          className="absolute top-4 right-4"
                        >
                          <div className="w-10 h-10 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center border border-white/30 group-hover:bg-white/30 transition-all">
                            <ExternalLink className="h-5 w-5 text-white" />
                          </div>
                        </motion.div>
                      )}
                    </div>

                    <CardContent className="p-6">
                      <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-orange-600 transition-colors">
                        {project.link ? (
                          <a 
                            href={project.link} 
                            target="_blank" 
                            rel="noopener noreferrer"
                            className="hover:text-orange-600"
                          >
                            {project.title}
                          </a>
                        ) : (
                          project.title
                        )}
                      </h3>
                      
                      <p className="text-gray-600 mb-4 leading-relaxed">
                        {project.description}
                      </p>
                      
                      {/* Technologies */}
                      <div className="flex flex-wrap gap-2 mb-4">
                        {project.technologies.slice(0, 3).map((tech, techIndex) => (
                          <span
                            key={techIndex}
                            className="px-2 py-1 bg-gray-100 text-gray-700 rounded-md text-xs font-medium"
                          >
                            {tech}
                          </span>
                        ))}
                        {project.technologies.length > 3 && (
                          <span className="px-2 py-1 bg-gray-100 text-gray-700 rounded-md text-xs font-medium">
                            +{project.technologies.length - 3} more
                          </span>
                        )}
                      </div>

                      {/* Visit Button */}
                      {project.link && (
                        <Button
                          onClick={() => window.open(project.link, '_blank')}
                          className="w-full bg-purple-600 hover:bg-purple-700 text-white"
                        >
                          View Project
                          <ExternalLink className="ml-2 h-4 w-4" />
                        </Button>
                      )}
                    </CardContent>
                  </Card>
                </motion.div>
              );
            })}
          </motion.div>
        </AnimatePresence>

        {/* Call to Action */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.8, duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mt-16"
        >
          <div className="bg-purple-600 rounded-3xl p-8 md:p-12 text-white">
            <h3 className="text-2xl md:text-3xl font-bold mb-4">
              Have a Project in Mind?
            </h3>
            <p className="text-lg md:text-xl mb-8 opacity-90">
              Let's discuss how we can bring your ideas to life with modern technology and clean code.
            </p>
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={() => {
                const element = document.getElementById('contact');
                if (element) {
                  element.scrollIntoView({ behavior: 'smooth' });
                }
              }}
              className="bg-white text-indigo-600 font-bold px-8 py-4 rounded-full hover:shadow-lg transition-all duration-300"
            >
              Get In Touch
            </motion.button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Portfolio;